export const ADD_FIRM_DETAILS = "ADD_FIRM_DETAILS";
export const FETCH_FIRM_DETAILS_LIST = "FETCH_FIRM_DETAILS_LIST";
export const EDIT_FIRM_DETAILS = "EDIT_FIRM_DETAILS";
export const UPDATE_FIRM_DETAILS = "UPDATE_FIRM_DETAILS";
export const DELETE_FIRM_DETAILS = "DELETE_FIRM_DETAILS";
